import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach bearer token from localStorage if cookie strategy is blocked (e.g., 3rd-party context)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mv_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Redirect to the pending-verification page on any 403 EMAIL_NOT_VERIFIED so
// users never see a raw error toast when poking at gated endpoints.
api.interceptors.response.use(
  (resp) => resp,
  (error) => {
    try {
      const detail = error?.response?.data?.detail;
      const code = (detail && typeof detail === "object") ? detail.code : null;
      if (error?.response?.status === 403 && code === "EMAIL_NOT_VERIFIED") {
        if (typeof window !== "undefined"
            && !window.location.pathname.startsWith("/pending-verification")
            && !window.location.pathname.startsWith("/verify-email")) {
          window.location.replace("/pending-verification");
        }
      }
    } catch { /* swallow */ }
    return Promise.reject(error);
  },
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
